/**
 * Barrel export for ikon-komponenter
 *
 * Eksporterer alle egne SVG-ikon-komponenter for enkel import:
 *   import { SearchIcon, NotificationIcon } from '@/components/icons';
 */

export { SearchIcon, NotificationIcon, SwitcherIcon, MenuIcon, LoginIcon, InfoIcon } from './Icon';
